import Body from "../components/Body";
import ReceiptsList from "../components/shopping/ReceiptsList";

export default function ShoppingReceiptPage() {
  return (
    <Body sidebar>
      <ReceiptsList />
    </Body>
  );
}


